<template>
  <div class="modal__offer">
    <div class="img" @click="$emit('close')">
      <img :src="mediaBaseUrl + 'after-quiz/close.svg'" alt="close">
    </div>

    <img :src="mediaBaseUrl + 'after-quiz/timeout.png'" alt="">
    <div class="bg"></div>

    <div class="modal-offer__content">
      <p>Time's up</p>
      <h2>Get your personalized plan and keep track of your health</h2>

      <div class="benefits">
        <div v-for="benefit in benefits" :key="benefit" class="benefit">
          <img :src="mediaBaseUrl + 'after-quiz/benefit-marker.svg'" alt="marker">
          <p>{{benefit}}</p>
        </div>
      </div>

      <custom-button @click="$emit('changeModal', 'payment')" :primary="true">
        Start Free Trial
      </custom-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "Register",
  inject: ["mediaBaseUrl"],

  data() {
    return {
      benefits: [
        "Measure health indicators with your phone",
        "Export health reports to show to your doctor or for yourself",
        "Eat right every day with our recipe book",
      ],
    };
  },

  methods: {
  },
}
</script>

<style lang="sass" scoped>
.modal__offer
  display: flex
  flex-direction: column
  align-items: center
  justify-content: flex-end
  position: relative
  max-height: 80vh
  height: 640px
  max-width: 508px
  width: 100%
  padding: 56px 33px
  border-radius: 16px
  overflow: hidden
  border: 1px solid rgba(168, 168, 168, 1)

  .img
    right: 24px
    top: 24px
    position: absolute
    z-index: 1
    padding: 12px
    cursor: pointer

  & > img
    top: 0
    left: 0
    position: absolute
    width: 100%

  .bg
    position: absolute
    background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.6) 60.5%, #000000 100%)
    width: 100%
    height: 100%
    bottom: 0
    left: 0

  .modal-offer__content
    z-index: 1

    & > p
      font-size: 1.5rem
      line-height: 1.65rem
      font-weight: 600
      margin-bottom: 8px
      text-align: center
      color: #ffffff

    .benefits
      display: flex
      flex-direction: column
      align-items: flex-start
      margin: 24px 0

    .benefit
      display: flex
      align-items: center
      margin-bottom: 14px

      p
        margin-left: 8px
        font-size: 1.125rem
        line-height: 1.125rem
        font-weight: 500
        color: #ffffff
        text-align: left

      &:last-child
        margin-bottom: 0

    h2
      font-size: 2rem
      line-height: 2.125rem
      color: #ffffff
      font-weight: 900
      text-align: center

    .button
      margin: 0 auto
</style>
